var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('zen-modal-wrapper',{attrs:{"modal":_vm.activeModal,"cache-types":_vm.cacheTypes,"size":_vm.size},on:{"close":_vm.hide,"updateConfig":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.updateModal.apply(void 0, [ 'config' ].concat( argsArray ))},"updateData":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.updateModal.apply(void 0, [ 'data' ].concat( argsArray ))}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }